import { Box } from "@mui/material";
import LightMedallionItem from "../inventory/medallions/LightMedallionItem";
import ForestMedallionItem from "../inventory/medallions/ForestMedallionItem";
import FireMedallionItem from "../inventory/medallions/FireMedallionItem";
import WaterMedallionItem from "../inventory/medallions/WaterMedallionItem";
import ShadowMedallionItem from "../inventory/medallions/ShadowMedallionItem";
import SpiritMedallionItem from "../inventory/medallions/SpiritMedallionItem";
import KokiriEmeraldItem from "../inventory/medallions/KokiriEmeraldItem";
import GoronRubyItem from "../inventory/medallions/GoronRubyItem";
import ZoraSapphireItem from "../inventory/medallions/ZoraSapphireItem";
import { MedallionProps } from "../inventory/medallions/MedallionInterface";
import { isNil } from "lodash";

interface RewordRewardTrackerProps{
    top: number,
    left: number,
    rewards: Array<RewardDto>,
    setReward: (r: RewardEnum, props: MedallionProps) => void
}

export interface RewardDto {
    id: RewardEnum,
    settings: MedallionProps
}

export enum RewardEnum {
    KokiriEmerald,
    GoronRuby,
    ZoraSapphire,
    ForestMedallion,
    FireMedallion,
    WaterMedallion,
    ShadowMedallion,
    SpiritMedallion,
    LightMedallion
}

const RewardRewardTracker = (props: RewordRewardTrackerProps) => {

    let originTop = 0;
    let originLeft = 0;

    let light = props.rewards.find(x => x.id === RewardEnum.LightMedallion);
    let forest = props.rewards.find(x => x.id === RewardEnum.ForestMedallion);
    let fire = props.rewards.find(x => x.id === RewardEnum.FireMedallion);
    let water = props.rewards.find(x => x.id === RewardEnum.WaterMedallion);
    let shadow = props.rewards.find(x => x.id === RewardEnum.ShadowMedallion);
    let spirit = props.rewards.find(x => x.id === RewardEnum.SpiritMedallion);
    let emerald = props.rewards.find(x => x.id === RewardEnum.KokiriEmerald);
    let ruby = props.rewards.find(x => x.id === RewardEnum.GoronRuby);
    let saphir = props.rewards.find(x => x.id === RewardEnum.ZoraSapphire);

    const setIsObtained = (r: RewardEnum, isObtained: boolean) => {
        if(!isNil(props.setReward))
            props.setReward(r, {...props.rewards.find(x => x.id === r)?.settings, isObtained: isObtained})
    }

    
    const setLabelIndex = (r: RewardEnum, index: number) => {
        if(!isNil(props.setReward))
            props.setReward(r, {...props.rewards.find(x => x.id === r)?.settings, indexLabel: index})
    }


    return <Box position={"absolute"} top={props.top} left={props.left}>
        <Box position={"absolute"} top={originTop} left={originLeft}>
            <LightMedallionItem {...light?.settings} 
            setIsObtained={(v) => {setIsObtained(RewardEnum.LightMedallion, v)}} 
            setIndexLabel={(v) => {setLabelIndex(RewardEnum.LightMedallion, v)}}
            />
        </Box>
        <Box position={"absolute"} top={originTop} left={originLeft+ 45}>
            <ForestMedallionItem  {...forest?.settings} 
                setIsObtained={(v) => {setIsObtained(RewardEnum.ForestMedallion, v)}} 
                setIndexLabel={(v) => {setLabelIndex(RewardEnum.ForestMedallion, v)}}
            />
        </Box>
        <Box position={"absolute"} top={originTop} left={originLeft+90}>
            <FireMedallionItem {...fire?.settings} 
                setIsObtained={(v) => {setIsObtained(RewardEnum.FireMedallion, v)}} 
                setIndexLabel={(v) => {setLabelIndex(RewardEnum.FireMedallion, v)}}
            />
        </Box>
        <Box position={"absolute"} top={originTop+50} left={originLeft}>
            <WaterMedallionItem {...water?.settings} 
                setIsObtained={(v) => {setIsObtained(RewardEnum.WaterMedallion, v)}} 
                setIndexLabel={(v) => {setLabelIndex(RewardEnum.WaterMedallion, v)}}
            />
        </Box>
        <Box position={"absolute"} top={originTop+50} left={originLeft+45}>
            <ShadowMedallionItem {...shadow?.settings} 
                setIsObtained={(v) => {setIsObtained(RewardEnum.ShadowMedallion, v)}} 
                setIndexLabel={(v) => {setLabelIndex(RewardEnum.ShadowMedallion, v)}}
            />
        </Box>
        <Box position={"absolute"} top={originTop+50} left={originLeft+90}>
            <SpiritMedallionItem {...spirit?.settings} 
                setIsObtained={(v) => {setIsObtained(RewardEnum.SpiritMedallion, v)}} 
                setIndexLabel={(v) => {setLabelIndex(RewardEnum.SpiritMedallion, v)}}
            />
        </Box>
        <Box position={"absolute"} top={originTop+100} left={originLeft}>
            <KokiriEmeraldItem {...emerald?.settings} 
                setIsObtained={(v) => {setIsObtained(RewardEnum.KokiriEmerald, v)}} 
                setIndexLabel={(v) => {setLabelIndex(RewardEnum.KokiriEmerald, v)}}
            />
        </Box>
        <Box position={"absolute"} top={originTop+100} left={originLeft+45}>
            <GoronRubyItem {...ruby?.settings} 
                setIsObtained={(v) => {setIsObtained(RewardEnum.GoronRuby, v)}} 
                setIndexLabel={(v) => {setLabelIndex(RewardEnum.GoronRuby, v)}}
            />
        </Box>
        <Box position={"absolute"} top={originTop+100} left={originLeft+90}>
            <ZoraSapphireItem {...saphir?.settings} 
                setIsObtained={(v) => {setIsObtained(RewardEnum.ZoraSapphire, v)}} 
                setIndexLabel={(v) => {setLabelIndex(RewardEnum.ZoraSapphire, v)}}
            />
        </Box>
    </Box>
}

export default  RewardRewardTracker;